import { portalTicketDayKey } from "./portal-ticket-dates";

export function portalOsVolumeForDay(items, dayKey) {
  return items.reduce(
    (totals, item) => {
      if (portalTicketDayKey(item.ticketCreatedAt || item.createdAt) === dayKey) totals.requested += 1;
      if (
        ["finished", "closed"].includes(item.status) &&
        portalTicketDayKey(item.finishedAt || item.attendanceEndedAt) === dayKey
      ) totals.solved += 1;
      return totals;
    },
    { requested: 0, solved: 0 },
  );
}
